import { useState } from "react";
import { ChevronDown, LogOut } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

const Pill = ({ item, active, onClick, badge }) => (
  <button
    data-testid={`side-${item.id}`}
    aria-current={active ? "page" : undefined}
    onClick={onClick}
    className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-3.5 sm:px-4 py-2 sm:py-2.5 text-xs sm:text-sm font-semibold transition-colors min-h-[40px] sm:min-h-[44px] tm-pill ${
      active ? "tm-negra" : "hover:bg-[#E6F2FA]"
    }`}
  >
    <item.icon className="h-4 w-4 shrink-0" />
    <span>{item.label}</span>
    {badge > 0 && <span className="rounded-full bg-[#5FA8D9] text-[#24331F] text-[11px] font-bold px-2 py-0.5 tabular-nums">{badge}</span>}
  </button>
);

// Pestañas horizontales en píldora: mismas secciones, orden y permisos que el menú lateral anterior.
export const TopNav = ({ section, onSelect, navItems, moduleItems, pagaresPend, isAdmin, onOpenAjustes, onLogout }) => {
  const [mas, setMas] = useState(false);
  const extras = [...moduleItems, ...(isAdmin ? [{ id: "ajustes", label: "Ajustes y permisos", icon: ChevronDown, onClick: onOpenAjustes }] : [])];
  return (
    <nav data-testid="dashboard-sidebar" className="flex flex-wrap items-center gap-1.5 min-w-0" aria-label="Secciones">
      {navItems.map((n) => (
        <Pill key={n.id} item={n} active={section === n.id} onClick={() => onSelect(n.id)} badge={n.id === "pagares-pendientes" ? pagaresPend : 0} />
      ))}
      {extras.length > 0 && (
        <DropdownMenu open={mas} onOpenChange={setMas} modal={false}>
          <DropdownMenuTrigger asChild>
            <button data-testid="side-mas" aria-expanded={mas}
              className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2.5 text-sm font-semibold min-h-[44px] tm-pill ${section === "ajustes" ? "tm-negra" : "hover:bg-[#E6F2FA]"}`}>
              Más <ChevronDown className={`h-4 w-4 transition-transform ${mas ? "rotate-180" : ""}`} />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" sideOffset={8} data-testid="side-mas-menu" className="tm-mas-menu z-50 min-w-[240px] max-w-[calc(100vw-2rem)] rounded-[22px] border p-2">
            {extras.map((m) => (
              <DropdownMenuItem key={m.id} data-testid={`side-${m.id}`} onSelect={() => m.onClick?.()} className="tm-mas-item">
                <m.icon className="h-4 w-4 text-[#007336] shrink-0" /> <span className="truncate">{m.label}</span>
              </DropdownMenuItem>
            ))}
            <DropdownMenuSeparator className="tm-mas-sep" />
            <DropdownMenuItem data-testid="side-logout" onSelect={() => onLogout?.()} className="tm-mas-item tm-mas-salir">
              <LogOut className="h-4 w-4 shrink-0" /> <span>Cerrar sesión</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </nav>
  );
};
